import { CustomLink } from "../../custom-link";
import { connect } from "react-redux";
import React from "react";
import get from "lodash/get";
import omit from "@babel/runtime/helpers/objectWithoutProperties";
import PropTypes from "prop-types";
import { SvgHandler } from "../../svg-handler/svg-handler";
import { breakpoint } from "../../../../utils/breakpoint";
import downArrowIcon from "../../../../assets/icons/down-arrow.svg";
import "./menu.m.css";

function MenuLink(props) {
  const { title, completeUrl, isExternalLink } = get(props, ["item"], {});

  return React.createElement(
    CustomLink,
    {
      href: completeUrl,
      ...(isExternalLink && { externalLink: completeUrl }),
      ...omit(props, ["item"])
    },
    title
  );
}

MenuLink.propTypes = {
  item: PropTypes.object
};

class MenuBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChild: null
    };
    this.toggleSubmenu = this.toggleSubmenu.bind(this);
  }

  toggleSubmenu(e) {
    e.stopPropagation();
    e.preventDefault();
    const currentChild = Number(e.currentTarget.dataset.id);
    const sidebar = e.currentTarget.dataset.sidebar;
    if (sidebar) {
      this.setState(function(prevState) {
        return {
          activeChild: prevState.activeChild === currentChild ? null : currentChild
        };
      });
    }
    if (breakpoint("tablet")) {
      if (this.props.primarySubmenu !== currentChild) {
        return this.props.openPrimarySubmenu(currentChild);
      }
      return this.props.closePrimarySubmenu();
    }
  }

  getMenuTypeLink(item, index) {
    if ((!this.props.sidebar && breakpoint("tablet")) || item["item-type"] === "placeholder") {
      return (
        <span onClick={this.toggleSubmenu} data-id={index}>
          {item.title}
        </span>
      );
    }
    return <MenuLink callback={this.props.closeAll} href={item.completeUrl} item={item} />;
  }

  render() {
    const {
      menu,
      sidebar,
      hasMoreItems,
      count,
      languageDirection = "left",
      primarySubmenu,
      closeAll,
      customCssClasses = "",
      type,
      isSingleLayer
    } = this.props;
    const singleLayerSelector = isSingleLayer ? "single-layer-" : "";
    const menuClass = sidebar ? "" : `${singleLayerSelector}header-${type}`;

    return (
      <ul
        data-menu="true"
        styleName={`menu ${customCssClasses} ${menuClass} top-level-menu ${
          primarySubmenu !== null ? "primary-menu-scroll" : ""
        }`}
      >
        {menu.slice(0, count).map((item, index) => {
          if (item.children.length && item["menu-group-slug"] !== "secondary-menu") {
            return (
              <li
                data-id={index}
                styleName={`menu-item has-child ${index === this.state.activeChild ? "submenu-open" : ""} ${
                  index === primarySubmenu ? "horizontal-submenu" : ""
                }`}
                key={`${item["id"]}${index}`}
              >
                {this.getMenuTypeLink(item, index, sidebar)}
                {sidebar && (
                  <span
                    data-sidebar={this.props.sidebar}
                    href="#"
                    styleName="arrow"
                    onClick={this.toggleSubmenu}
                    data-id={index}
                  >
                    <SvgHandler width="24px" height="24px" xlinkHref={downArrowIcon} />
                  </span>
                )}
                <ul
                  data-submenu="true"
                  styleName={`sub-menu ${index === this.state.activeChild ? "open" : "close"} ${
                    languageDirection === "right" ? "sub-menu-rtl" : ""
                  } ${index === primarySubmenu ? "open-submenu" : ""}`}
                >
                  {!breakpoint("tablet") || item["item-type"] === "placeholder" || sidebar ? null : (
                    <li styleName="sub-menu-placeholder">
                      <MenuLink callback={closeAll} item={item} />
                    </li>
                  )}
                  {item.children.map((child, index) => {
                    return (
                      <li styleName="sub-menu-item" key={`${child["id"]}${index}`}>
                        <MenuLink callback={closeAll} item={child} />
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          }

          return (
            <li styleName="menu-item" key={`${item["id"]}${index}`}>
              {item["item-type"] === "placeholder" ? (
                <span>{item.title}</span>
              ) : (
                <MenuLink callback={closeAll} item={item} />
              )}
            </li>
          );
        })}
        {hasMoreItems && (
          <li styleName="menu-item has-child">
            More
            <ul styleName="sub-menu">
              {menu.slice(count).map((item, index) => (
                <li styleName="sub-menu-item" key={`${item["id"]}${index}`}>
                  <MenuLink callback={closeAll} item={item} />
                </li>
              ))}
            </ul>
          </li>
        )}
      </ul>
    );
  }
}

MenuBase.propTypes = {
  item: PropTypes.object,
  menu: PropTypes.array,
  sidebar: PropTypes.bool,
  hasMoreItems: PropTypes.bool,
  count: PropTypes.number,
  languageDirection: PropTypes.string,
  primarySubmenu: PropTypes.number,
  openPrimarySubmenu: PropTypes.func,
  closePrimarySubmenu: PropTypes.func,
  closeAll: PropTypes.func,
  customCssClasses: PropTypes.string,
  type: PropTypes.string,
  isSingleLayer: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    isSidebarVisible: get(state, ["header", "isSidebarVisible"]),
    primarySubmenu: get(state, ["header", "primarySubmenu"])
  };
};

const mapDispatchToProps = dispatch => ({
  openPrimarySubmenu: menuId => dispatch({ type: "OPEN_PRIMARY_SUBMENU", payload: { menuId } }),
  closePrimarySubmenu: () => dispatch({ type: "CLOSE_PRIMARY_SUBMENU" })
});

export const Menu = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuBase);
